// import { useState } from 'react';

// const StudentDocumentThumbnail = ({ document }) => {
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   if (!document) return null;

//   try {
//     const { path } = typeof document === 'string' ? JSON.parse(document) : document;
//     const imageUrl = path.replace('/home/ilfkksa', 'https:/'); // Convert to valid URL
    
//     return (
//       <div className="p-2">
//         {/* Thumbnail */}
//         <div 
//           className="w-20 h-20 cursor-pointer overflow-hidden rounded-md border border-gray-200"
//           onClick={() => setIsModalOpen(true)}
//         >
//           <img 
//             src={imageUrl} 
//             alt="Student document" 
//             className="w-full h-full object-cover hover:opacity-90"
//             onError={(e) => {
//               e.target.onerror = null; 
//               e.target.src = 'https://via.placeholder.com/80?text=No+Image';
//             }}
//           />
//         </div>

//         {/* Modal for full-size image */}
//         {isModalOpen && (
//           <div 
//             className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
//             onClick={() => setIsModalOpen(false)}
//           >
//             <div className="relative max-w-full max-h-full">
//               <img 
//                 src={imageUrl} 
//                 alt="Student document" 
//                 className="max-w-[90vw] max-h-[90vh] object-contain"
//               />
//               <button 
//                 className="absolute top-4 right-4 bg-white rounded-full p-2 shadow-lg"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setIsModalOpen(false);
//                 }}
//               >
//                 ✕
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   } catch (error) {
//     console.error("Error parsing student document:", error);
//     return (
//       <div className="p-2 text-xs text-red-500">
//         Invalid document format
//       </div>
//     );
//   }
// };

// export default StudentDocumentThumbnail;
import { useState } from 'react';

const StudentDocumentThumbnail = ({ document }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!document) return null;

  try {
    const { path } = typeof document === 'string' ? JSON.parse(document) : document;
    const fileUrl = path.replace('/home/ilfkksa', 'https:/'); // Adjust path
    const fileExtension = fileUrl.split('.').pop().toLowerCase();

    const isImage = ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension);
    const isPDF = fileExtension === 'pdf';

    return (
      <div className="p-2">
        <div 
          className="w-20 h-20 cursor-pointer overflow-hidden rounded-md border border-gray-200 flex items-center justify-center bg-gray-100"
          onClick={() => setIsModalOpen(true)}
        >
          {isImage ? (
            <img 
              src={fileUrl} 
              alt="Student document" 
              className="w-full h-full object-cover hover:opacity-90"
              onError={(e) => {
                e.target.onerror = null; 
                e.target.src = 'https://via.placeholder.com/80?text=No+Image';
              }}
            />
          ) : isPDF ? (
            <span className="text-xs text-gray-700">PDF Document</span>
          ) : (
            <span className="text-xs text-gray-500">Unsupported</span>
          )}
        </div>

        {isModalOpen && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
            onClick={() => setIsModalOpen(false)}
          >
            <div className="relative max-w-full max-h-full bg-white p-4 rounded">
              {isImage ? (
                <img 
                  src={fileUrl} 
                  alt="Student document" 
                  className="max-w-[90vw] max-h-[90vh] object-contain"
                />
              ) : isPDF ? (
                <iframe 
                  src={fileUrl}
                  title="PDF Viewer"
                  className="w-[80vw] h-[90vh]"
                />
              ) : (
                <p className="text-white">Unsupported document format</p>
              )}
              <button 
                className="absolute top-4 right-4 bg-white rounded-full p-2 shadow-lg"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsModalOpen(false);
                }}
              >
                ✕
              </button>
            </div>
          </div>
        )}
      </div>
    );
  } catch (error) {
    console.error("Error parsing student document:", error);
    return (
      <div className="p-2 text-xs text-red-500">
        Invalid document format
      </div>
    );
  }
};

export default StudentDocumentThumbnail;
